module.exports = __webpack_public_path__ + "img/pie11111.c8e0c9e4.png";